// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    payments: path(ROOTS_DASHBOARD, '/payments'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    /* TODO: Remove */
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    banking: path(ROOTS_DASHBOARD, '/banking')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  yachts: {
    root: path(ROOTS_DASHBOARD, '/yachts'),
    list: path(ROOTS_DASHBOARD, '/yachts/list'),
    create: path(ROOTS_DASHBOARD, '/yachts/create')
  },
  specialOffers: path(ROOTS_DASHBOARD, '/special-offers/matrix'),
  reservations: {
    root: path(ROOTS_DASHBOARD, '/reservations'),
    list: path(ROOTS_DASHBOARD, '/reservations/list'),
    matrix: path(ROOTS_DASHBOARD, '/reservations/matrix'),
    create: path(ROOTS_DASHBOARD, '/reservations/create')
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    all: path(ROOTS_DASHBOARD, '/invoice/all')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  settings: {
    root: path(ROOTS_DASHBOARD, '/settings/templates'),
    templates: path(ROOTS_DASHBOARD, '/settings/templates')
  },
  reviews: {
    root: path(ROOTS_DASHBOARD, '/reviews'),
    list: path(ROOTS_DASHBOARD, '/reviews/list')
  },

  /* TODO: Remove */
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  },
  zegluj: {
    payouts: path(ROOTS_DASHBOARD, '/zegluj/payouts')
  },
  reports: {
    bosuns: path(ROOTS_DASHBOARD, '/reports/bosuns'),
    cleaningService: path(ROOTS_DASHBOARD, '/reports/cleaning-service')
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
